<template>
  <v-container text-xs-center fluid>
    <v-card rounded-pill width="1100px" class="pa-1 mb-1 mx-auto" outlined color="transparent">
      <v-form>
        <v-layout wrap >
          <v-text-field dense outlined style="height: 45px; margin:5px; max-width:160px !important;"
            id="sensor_mac" 
            ref="sensor_mac" 
            label="센서노드 맥ID✽" 
            v-model="sensor_mac"
            @keyup="sensorMacMask(sensor_mac)"
            maxlength="20"
          />
          <!-- <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field dense outlined style="height:40px; max-width:195px; margin:6px;" class="calendar shrink rounded mt-1 ml-1 mb-1"
              id="to_date" 
              ref="to_date" 
              v-model="to_date"
              label="조회일시"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            no-title locale="ko-KR"
            v-model="to_date"
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu> -->
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="300"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-bind="attrs"
              v-on="on"
              v-model="DateTime"
              label="날짜/시간"
              append-icon="mdi-calendar-clock"
              readonly
              dense
              outlined
              style="height: 40px; max-width: 210px; margin: 6px;"
            />
          </template>

          <v-card mx-auto>
            <v-date-picker
              v-model="fr_date"
              locale="ko-KR"
              no-title
            ></v-date-picker>

            <template>
              <v-row
                align="center"
                justify="space-around"
              >
                <v-time-picker
                  use-seconds 
                  v-model="fr_time"
                  format="24hr"
                  scrollable
                ></v-time-picker>
              </v-row>
            </template>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="setDateTime">확인</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>

        <v-text-field dense outlined style="height: 45px; margin:5px; max-width:100px !important;"
          type="number"
          id="dataCnt" 
          ref="dataCnt" 
          label="조회갯수" 
          v-model="dataCnt"
        />

        <v-btn class="elevation-5 ma-1 rounded normal-btn" style="height: 40px; width: 70px margin:5px; background-color:#3a4f3f; border-radius:20px !important; "
          id="refreshList" 
          :loading="loading" 
          ref="refreshList" 
          type="submit" 
          @click.prevent="currentData()">
          <img src="@/assets/icon_search.svg" alt="새로고침" />
        </v-btn>
        </v-layout>
      </v-form>
    </v-card>
    <v-card rounded-pill width="1100px" class="pa-1 mb-1 mx-auto" outlined color="transparent">
      <div class="live_sensor">
        <v-icon class="mr-1">mdi-alarm</v-icon>
        <span class="live_title">최종 데이터 수신 시간</span>
        <span class="live_value mr-5">{{ nowItem.date }}</span>

        <v-icon>mdi-thermometer</v-icon>
        <span class="live_title">온도</span>
        <span class="live_value">{{ nowItem.temp }}</span>
        <span class="unit">℃</span>

        <v-icon>mdi-water</v-icon>
        <span class="live_title">습도</span>
        <span class="live_value">{{ nowItem.hum }}</span>
        <span class="unit">%</span>

        <v-icon>mdi-cloud</v-icon>
        <span class="live_title">CO<sub style="font-size:12px;">2</sub></span>
        <span class="live_value">{{ nowItem.co2 }}</span>
        <span class="unit">ppm</span>

        <v-icon>mdi-cloud-outline</v-icon>
        <span class="live_title">NH<sub style="font-size:12px;">3</sub></span>
        <span class="live_value">{{ nowItem.nh3 }}</span>
        <span class="unit">ppm</span>
      </div>
    </v-card>  
    <v-card rounded-pill width="1100px" class="pa-1 mb-1 mx-auto" outlined color="transparent">
      <v-data-table  dense height="550"
          id="time__table"
          fixed-header
          :footer-props="{
                // showFirstLastPage: true,
                // disableItemsPerPage: true,
                itemsPerPageOptions:[-1]
              }"
          :loading="loading" 
          :headers="headers"
          :items="items"
          no-data-text="측정된 자료가 없습니다."
          class="elevation-2"
          item-key="checkDateTime"
          single-select
          :sort-by= "['checkDate','checkTime']"
          :sort-desc= "[true,true]"
          :search="search"

        />

        <v-btn class="report__btn mt-3" @click="Report()" >
          <v-icon size="medium" color="white">mdi-file-document</v-icon>
          엑셀다운
        </v-btn>
    </v-card>

   
 </v-container>
</template>

<script>
import Apis from '@/api/apis';
import VueCookies from "vue-cookies";
import Common from "@/utils/custom/common.js";
import * as Xlsx from 'xlsx'

import dateUtil from "@/utils/custom/dateProperty.js";
var setTime = 0;

export default {
  name: 'SensorTest',

  async created() {
    Apis.pageCount({
      page_name: this.$route.name,
      url: this.$route.path,
      division: "pigro",
    },() => {  // 정상처리
      // console.log("pageCount 호출",res);
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });


    let cdate = new Date();
    this.fr_date = dateUtil.format(cdate, "yyyy-MM-dd");
    this.fr_time = dateUtil.format(cdate, "HH:mm:ss");
    this.DateTime = `${this.fr_date} ${this.fr_time}`;

    let cookie_info = VueCookies.get("sensortest");
    if (cookie_info) {
      this.sensor_mac = cookie_info.sensor_mac;
    }
  },
  destroyed() {
    clearTimeout(setTime);
  },
  data () {
    return {
      sensor_mac:'',

      menu1: false,
      fr_date:'',
      fr_time:'',
      DateTime:'',
      nowTime:'',

      dataCnt:50,

      loading:false,
      headers: [
        { text: '측정일시', align: 'left', value: 'date', filterable: true, sortable: true, groupable: false, width: "130px", divider: true,show: true},
        { text: '온도 ℃', align: 'end', value: 'temp', filterable: false, sortable: true, groupable: false, width: "110px",divider: true, show: true },
        { text: '습도 %', align: 'end', value: 'hum', filterable: false, sortable: true, groupable: false, width: "110px", divider: true, show: true },
        { text: '이산화탄소 ppm', align: 'end', value: 'co2', filterable: false, sortable: true, groupable: false, width: "130px",divider: true , show: true },
        { text: '암모니아 ppm', align: 'end', value: 'nh3', filterable: false, sortable: true, groupable: false, width: "120px", show: true},
      ],
      items:[],
      nowItem:{},

      search:'',

    }
  },
  methods: {
    setDateTime(){
      if (this.fr_date && this.fr_time) {
        this.DateTime = `${this.fr_date} ${this.fr_time}`;
      } else if (this.fr_date) {
        this.DateTime = this.fr_date;
      }
      this.menu1 = false;
    },
    currentData(){
      let cdate = new Date();
      this.fr_date = dateUtil.format(cdate, "yyyy-MM-dd");
      this.fr_time = dateUtil.format(cdate, "HH:mm:ss");
      this.nowTime = `${this.fr_date} ${this.fr_time}`; 

      // console.log(this.nowTime);

      Apis.listRawValuesOfSensor({
        mac:this.sensor_mac.replace(/:/gi, ''),
        stand_time: this.nowTime,
        number : 1
      },(res) => {  
        if (res.result) {
          this.nowItem = res.data[0];
          // console.log(this.nowItem)

          this.loading = false;

          this.$route.path == "/sensorTest" ? setTime = setTimeout( () =>  this.currentData(), 60000) : "" ;

        }
      })
      this.refreshList();
    },
    refreshList(){
      // console.log(this.sensor_mac.replace(/:/gi, ''))
      // console.log(this.DateTime)
      // console.log(this.dataCnt)
      if  (!this.sensor_mac) {
        alert("센서노드 맥 주소를 입력하세요");
        this.$refs.sensor_mac.focus();
        return;
      }
      if  (!this.DateTime) {
        alert("날짜 및 시간을 선택하세요");
        this.$refs.DateTime.focus();
        return;
      }
      if (!this.dataCnt || Number(this.dataCnt) <= 0) {
        alert("조회 갯수는 1 이상이어야 합니다.");
        return;
      }
      this.$store.commit("resMessage","");
      this.loading = true;
      this.items = [];

      Apis.listRawValuesOfSensor({
        mac:this.sensor_mac.replace(/:/gi, ''),
        stand_time: this.DateTime,
        number : Number(this.dataCnt)
      },(res) => {  
        if (res.result) {
          this.items = res.data;

          this.$store.commit("resMessage",res.message);
          let cookie_info = { sensor_mac: this.sensor_mac };
          VueCookies.set("sensortest" ,cookie_info,"30d");
        }else{
          alert(res.message);
        }
        
        this.loading = false;
      }).catch( (err) => {  // API 오류 처리
        console.log("listRawValuesOfSensor API 호출 오류",err)
        alert(err);
        this.loading = false;
      })
    },
    
    sensorMacMask(val) {
      // let res = Common.getRegMask(val)
      this.sensor_mac = Common.getMacMask(val)
    },

    Report(){
      let today = new Date();   
      let hours = today.getHours();
      let minutes = today.getMinutes();  

      // 날짜 문자열로
      const itemsForExcel = this.items.map(item => ({
        date: `'${item.date}`, // 문자열로 날짜+시간 표시
        temp: item.temp,
        hum: item.hum,
        co2: item.co2,
        nh3: item.nh3
      }));

      // 열 순서 명시
      const headers = ['date', 'temp', 'hum', 'co2', 'nh3'];

      const sheet = Xlsx.utils.json_to_sheet(itemsForExcel, { header: headers });
      
      const headerNames = ['측정일시', '온도', '습도', 'CO₂', 'NH₃'];
      Xlsx.utils.sheet_add_aoa(sheet, [headerNames], { origin: 'A1' });

      const workBook = Xlsx.utils.book_new();
      Xlsx.utils.book_append_sheet(workBook, sheet, '지표데이터');
      Xlsx.writeFile(workBook, `데이터_${hours}시 ${minutes}분.xlsx`);
    }
   


  }  // -----------methods 

}
</script>

<style lang="scss" scoped>
.v-data-table::v-deep{
  thead.v-data-table-header tr {
    th {
      background-color: #436251 !important;
      color: white !important;
      font-size:13px;
      height:40px !important;
    }
  }
}
.report__btn{
  background-color:#3a4f3f !important;
  color:white !important;
  border-radius:30px;
}
::v-deep .v-time-picker-title{
  margin-top:-30px !important;
  margin:20px;
  font-size:15px !important;
}
::v-deep .v-time-picker-title__time{
  margin:0 auto;
  height:25px !important;
}
::v-deep .v-picker__title__btn{
  font-size:25px;
}
::v-deep .v-time-picker-title__time .v-picker__title__btn {
  // display:inline-flex;
  align-items:initial !important;
}
::v-deep .v-time-picker-title__time span{
  font-size:25px;
}
.live_sensor{
  background-color: #ededed;
  padding:10px 20px;
  display: flex;
  letter-spacing: -1px;
  justify-content: center;
  border-radius: 30px !important;
}
.live_title{
  margin-right:15px;
}
.live_value, .unit{
  font-weight:550;
}
.unit{
  margin-right:15px;
  font-size:13px;
}

</style>
